import type { Facet } from '@apptus/esales-api';
import type { Filter } from '@server/utils/parseLoop/types';

const FILTER_BLACKLIST = [
    'custom.brandCode',
    'custom.designerCode',
    'custom.totalCategoryCodes',
];

function mapElevateFacetToNgFilter(facet: Facet): Filter | undefined {
    if (facet.type === 'CHECKBOX') {
        return;
    }
    if (facet.type === 'TEXT') {
        return {
            type: 'checkbox',
            show: true,
            name: facet.label,
            attribute: facet.id,
            extras: {
                openByDefault: true,
            },
            values: facet.values.filter((v) => v.selected).map((v) => v.id),
            items: facet.values.map((value) => ({
                count: value.count,
                name: value.id,
            })),
        };
    }
    if (facet.type === 'RANGE') {
        const { min = 0, max = 999999, minSelected, maxSelected } = facet;
        let values: [number, number] | undefined = undefined;
        if (minSelected !== undefined && maxSelected !== undefined) {
            values = [minSelected, maxSelected];
        } else if (minSelected !== undefined) {
            values = [minSelected, max];
        } else if (maxSelected !== undefined) {
            values = [min, maxSelected];
        }
        return {
            type: 'range',
            show: true,
            name: facet.label,
            attribute: facet.id,
            values,
            min,
            max,
            extras: {
                openByDefault: true,
                minLabel: '',
                maxLabel: '',
            },
        };
    }
    if (facet.type === 'SIZE') {
        return;
    }
    if (facet.type === 'COLOR') {
        return;
    }
    return;
}

export default function mapElevateFacets(facets: Facet[]): Filter[] {
    const whitelistedFacets = facets.filter(
        (facet) => !FILTER_BLACKLIST.includes(facet.id),
    );
    return whitelistedFacets
        .map(mapElevateFacetToNgFilter)
        .filter(Boolean) as Filter[];
}
